


















































































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { timeFormat } from "@/utils";

@Component({
  name: "warn",
})
export default class CombinationProperty extends Vue {
  @Prop() repaymentPlanData: any;
  @Prop() repayplanstageList: any;
  @Provide() group: any = [];
  @Provide() groupList: any = [];
  @Provide() activeName: any = "first";

  private created() {
    this.dwTableList(this.repaymentPlanData, this.group);
    this.dwTableList(this.repayplanstageList, this.groupList);
  }
  private handleClick(tab: any, event: any) {
  }
  private dwTableList(data: any, list: any) {
    if (data && data.group && data.group.length > 0) {
      // data.group.forEach((item: any, index: number) => {
      //   if (index % 2 === 0) {
      //     let groupItem: any = [item];
      //     list.push(groupItem);
      //   } else {
      //     list[list.length - 1].push(item);
      //   }
      // })
      list = data.group;
    }
  }
}
